import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

import formatUtcToLocalDate from 'utils/formatUtcToLocalDate';

import timeDateFormat from 'config/timeDateFormat';

import EventLogViewTableRow from './EventLogViewTableRow';

const styles = theme => ({
  root: {
    padding: '0',
    overflow: 'hidden',
  },
  typography: {
    marginLeft: 24,
    marginBottom: 16,
  },
  tableHead: {
    backgroundColor: theme.palette.grey[100],
  },
  tableRow: {
    height: 35,
  },
  tableCell: {
    paddingTop: 5,
    paddingBottom: 5,
    borderTop: `1px solid ${theme.palette.primary.A100}`,
  },
  tableCellDate: {
    width: 126,
  },
  tableCellActions: {
    width: 16,
    paddingRight: 29,
    '&:last-child': {
      paddingRight: 29,
    },
  },
  tableCellEmpty: {
    textAlign: 'center',
  },
});

const EventLogViewTableHead = ({
  eventLog,
  date,
  business,
  classes,
}) => (
  <div className={classes.root}>
    {date &&
      <Typography
        className={classes.typography}
        color="secondary"
      >
        Last updated {formatUtcToLocalDate(
          date,
          timeDateFormat,
          timeDateFormat,
          business['Company Address']['Time Zone'],
          business['Company Address']['Observes Daylight Saving'],
        )}
      </Typography>
    }
    <Table className={classes.table}>
      <TableHead className={classes.tableHead}>
        <TableRow className={classes.tableRow}>
          <TableCell className={classNames(classes.tableCell, classes.tableCellDate)}>
            Date
          </TableCell>
          <TableCell className={classes.tableCell}>Activity</TableCell>
          <TableCell className={classNames(classes.tableCell, classes.tableCellActions)} />
        </TableRow>
      </TableHead>
    </Table>
  </div>
);

EventLogViewTableHead.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  date: PropTypes.object,
  business: PropTypes.shape({
    ID: PropTypes.number,
  }),
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
    typography: PropTypes.string.isRequired,
    tableHead: PropTypes.string.isRequired,
    tableRow: PropTypes.string.isRequired,
    tableCell: PropTypes.string.isRequired,
    tableCellDate: PropTypes.string.isRequired,
    tableCellActions: PropTypes.string.isRequired,
  }).isRequired,
};

EventLogViewTableHead.defaultProps = {
  date: null,
  business: {},
};

export default withStyles(styles)(EventLogViewTableHead);



// WEBPACK FOOTER //
// ./src/components/patient/EventLogViewDialog/EventLogViewTableHead.js